import React from 'react';
import { Modal } from 'native-base';
import RichTextBox from './RichTextBox';
import { NEW_REPLY_MODAL_MIN_HEIGHT, MODAL_WIDTH } from '../../../Constants';
const NewReplyBox = _ref => {
  var _topic$id;
  let {
    topic,
    reply,
    showNewReplyModal,
    setShowNewReplyModal,
    handleTopicReply,
    onCloseHandler
  } = _ref;
  const topicId = (_topic$id = topic === null || topic === void 0 ? void 0 : topic.id) !== null && _topic$id !== void 0 ? _topic$id : reply === null || reply === void 0 ? void 0 : reply.topic_id;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: showNewReplyModal,
    onClose: () => setShowNewReplyModal(false),
    size: MODAL_WIDTH,
    w: "container",
    minH: NEW_REPLY_MODAL_MIN_HEIGHT,
    _overlay: {
      style: {
        position: 'fixed'
      }
    }
  }, /*#__PURE__*/React.createElement(Modal.Content, {
    minH: NEW_REPLY_MODAL_MIN_HEIGHT
  }, /*#__PURE__*/React.createElement(Modal.CloseButton, null), /*#__PURE__*/React.createElement(Modal.Header, null, "Write a reply"), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(RichTextBox, {
    topicId: topicId,
    handleTopicReply: handleTopicReply,
    setShowModal: setShowNewReplyModal,
    onCloseHandler: onCloseHandler,
    id: "newReply",
    key: "newReply"
  }))));
};
export default NewReplyBox;
//# sourceMappingURL=NewReplyBox.js.map